<script>

    import Icon from '../Icon.svelte';
    import exclamationIcon from '../../assets/icons/exclamation.svg?raw';
    import informationIcon from '../../assets/icons/information.svg?raw';
    import Markdown from '../Markdown.svelte';

    let { item } = $props();

</script>

<div class='information' data-style="{item.style}">

    {#if item.style === 'info'}
        <Icon data={informationIcon} />
    {:else if item.style === 'warning'}
        <Icon data={exclamationIcon} />
    {/if}

    <div>
        <h4>
            {item.name}
        </h4>

        {#if item.description}
            <div class="body"><Markdown source={item.description} /></div>
        {/if}
    </div>
</div>

<style>

    div.information {
        margin: 1rem 0 2rem;

        display: grid;
        grid-template-columns: 1fr;
    }

    div.information[data-style='warning'],
    div.information[data-style='info'] {
        margin: 2rem 0;

        border: 2px solid #eee;
        border-radius: 0.5rem;
        
        padding: 1rem;
        grid-template-columns: min-content 1fr;
    }

    div.information[data-style='warning'] {
        background: var(--warning-color);
        border: none;
        color: #fff;
    }

    div.information[data-style='info'] {
        background: var(--info-background);
        border: none;
        border-color: var(--info-color);
    }

    div :global(svg) {
        width: 1.4rem;
        height: 1.4rem;

        vertical-align: middle;
        margin-right: 0.5rem;
    }

    div[data-style='warning'] :global(svg) {
        color: #fff;
    }

    div[data-style='info'] :global(svg) {
        color: var(--info-color);
    }



    h4 {
        margin: 0 0 0.3rem;
        font-size: 1rem;
    }

    div.information[data-style='info'] h4 {
        color: var(--info-color);
    }

    .body {
        font-size: 0.9rem;
    }

</style>
